import React, { forwardRef } from "react"
import { Dropdown } from "react-bootstrap"

import classes from "./EditorHeading.module.scss"

const EditorHeading = (props) => {
  const { editor } = props

  const handleClick = (value) => {
    editor.chain().focus().setHeading({ level: parseInt(value) }).run()
  }

  const value =
    editor.isActive("paragraph")
      ? 0
      : editor.getAttributes("heading").level

  return (
    <div className={classes["container"]}>
      <Dropdown className={classes["dropdown-button"]}>
        <Dropdown.Toggle
          as={forwardRef((props, ref) =>
            <button
              ref={ref}
              {...props}
              className={classes["button"]}
            >
              {value === 0 && "Paragraph"}
              {value === 1 && "H1"}
              {value === 2 && "H2"}
              {value === 3 && "H3"}
              {value === 4 && "H4"}
              {value === 5 && "H5"}
              {value === 6 && "H6"}
            </button>
          )}
        />

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => editor.chain().focus().setParagraph().run()}
          >
            Paragraph
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("1")}
          >
            H1
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("2")}
          >
            H2
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("3")}
          >
            H3
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("4")}
          >
            H4
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("5")}
          >
            H5
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick("6")}
          >
            H6
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

    </div>
  )
}

export default EditorHeading